module.exports = __webpack_public_path__ + "img/switch.1d3349f2.svg";